export function registrationUrl(shortName: string): string {
  return (
    "https://sans.org/" +
    shortName +
    "?utm_medium=Referral&utm_source=OD+Player&utm_campaign=Course+Demo&utm_content=" +
    shortName +
    "+RegisterRight"
  );
}
